module.exports = __webpack_public_path__ + "img/slide_4.ff7fa1f0.webp";